import { useOutletContext } from 'react-router-dom'

export const useClientsContext = () => useOutletContext<{ selectedCompanyId: string | null }>()
